import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { TabField } from "@/types";

interface FeedTab extends TabField {
  visible: () => boolean;
}

/**
 * Top navigation of the feed pages (Feed / Discover / Creators / Search).
 * The "home" tab is labelled "Feed" on onlyfats (CO-15555).
 * One entry per tab: a new tab is one more line in this list.
 */
const feedTabs = (): FeedTab[] => [
  { name: "home", text: $t("Feed"), to: { name: "home" }, visible: () => true },
  { name: "discover", text: $t("Discover"), to: { name: "discover" }, visible: () => !config.featureSoloModel },
  {
    name: "creators",
    text: $t("Creators"),
    to: { name: "creatorsAll" },
    visible: () => config.featureDiscoveryCreators && !config.featureSoloModel,
  },
  // hashtag search of Discover; route "search" exists on the same condition (router/routes/public.ts)
  {
    name: "search",
    text: $t("Search"),
    to: { name: "search" },
    visible: () => config.featureHashtags && !config.featureSoloModel,
  },
];

export const getFeedTabs = ({ withHome = true }: { withHome?: boolean } = {}): TabField[] =>
  feedTabs()
    .filter(tab => tab.visible() && (withHome || tab.name !== "home"))
    .map(({ visible, ...tab }) => tab);
